/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import PropTypes from 'prop-types'
import {
  Form,
  FormInput,
  FormButton,
  Link,
  Margin,
  Text,
} from 'shared/components'
import { auth } from 'routes/route.map'
import config from 'config'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import * as styles from './styles'

const LoginFormComponent = ({ form, onSubmit }) => {
  const onGoogleLogin = () => {
    const redirect = encodeURIComponent(globalThis.location.href)
    globalThis.location.href = `${config.api.url}/oauth2/authorization/google?redirect=${redirect}`
  }

  return (
    <Form form={form} onSubmit={onSubmit}>
      <Margin bottom={2}>
        <FormInput
          name="email"
          label="Email"
          type="email"
          placeholder="account@email.com"
          strictLong
        />
      </Margin>
      <Margin tb={1}>
        <FormInput
          name="password"
          label="Password"
          type="password"
          placeholder="********"
          strictLong
        />
      </Margin>
      <Margin top={2}>
        <div css={styles.controlWrapper}>
          <div css={styles.forgotPasswordBlock}>
            <Link to={auth.resetPassword()}>
              <Text size={16}>Forgot Password?</Text>
            </Link>
          </div>
          <FormButton submit medium green css={styles.loginButton}>
            <Text size={16} upper bold black>
              Log In
            </Text>
          </FormButton>
        </div>
      </Margin>
      <Margin top={3}>
        <div css={styles.separator}>
          <span css={styles.separatorText}>OR</span>
        </div>
      </Margin>
      <Margin top={2}>
        <FormButton
          medium
          type="button"
          css={styles.googleButton}
          onClick={onGoogleLogin}
        >
          <FontAwesomeIcon icon={['fab', 'google']} css={styles.googleIcon} />
          <Text size={16} bold white>
            Continue with Google
          </Text>
        </FormButton>
      </Margin>
    </Form>
  )
}

LoginFormComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default LoginFormComponent
